const emailRegex = /^(?:(?:[\w`~!#$%^&*\-=+;:{}'|,?\/]+(?:(?:\.(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)*"|[\w`~!#$%^&*\-=+;:{}'|,?\/]+))*\.[\w`~!#$%^&*\-=+;:{}'|,?\/]+)?)|(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)+"))@(?:[a-zA-Z\d\-]+(?:\.[a-zA-Z\d\-]+)+|\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])$/;

export function isEmail(value: string) {
    return emailRegex.test(value);
}

const strongPasswordRegex = /^(?=.*(\d|[^\w\s]))(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
export const invalidPasswordMessage = 'Your password must be at least 8 characters long. It should also include 1 uppercase letter and 1 number or symbol.';

export function isValidPassword(value: string) {
    return strongPasswordRegex.test(value);
}


export function isJsonString(str: string): boolean {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}
